<script lang="ts">
import { defineComponent, PropType } from 'vue'

import {
  CricketIncidentId,
  IllegalBallAttributesId,
} from '@collector/sportsapi-client-legacy'
import { ToggleButtonGroupOption } from '@mobile/components/ToggleButton/ToggleButtonGroup.vue'
import { PopupContext } from '@mobile/views/Relation/Shared/Popup/builder/types'

import SelectNumberOfPopup from '../SelectNumberOf/SelectNumberOfPopup.vue'

export default defineComponent({
  components: { SelectNumberOfPopup },
  props: {
    context: {
      type: Object as PropType<PopupContext | null>,
      required: false,
    },
  },
  setup() {
    const incidentId: CricketIncidentId.IllegalBall =
      CricketIncidentId.IllegalBall
    const coreAttributeId = IllegalBallAttributesId.Wides
    const options: ToggleButtonGroupOption[] = [
      {
        name: 'Wide',
        value: IllegalBallAttributesId.One,
      },
      {
        name: 'Wide+1',
        value: IllegalBallAttributesId.Two,
      },
      {
        name: 'Wide+2',
        value: IllegalBallAttributesId.Three,
      },
      {
        name: 'Wide+3',
        value: IllegalBallAttributesId.Four,
      },
      {
        name: 'Wide+4',
        value: IllegalBallAttributesId.Five,
      },
      {
        name: 'Wide+5',
        value: IllegalBallAttributesId.Six,
      },
      {
        name: 'Wide+6',
        value: IllegalBallAttributesId.Seven,
      },
      {
        name: 'Wide+7',
        value: IllegalBallAttributesId.Eight,
      },
      {
        name: 'Wide+8',
        value: IllegalBallAttributesId.Nine,
      },
      // TODO add 10 after API update
      {
        name: 'Wide+9',
        value: IllegalBallAttributesId.Nine,
      },
    ]

    return {
      options,
      incidentId,
      coreAttributeId,
    }
  },
})
</script>

<template>
  <div class="h-full w-full">
    <SelectNumberOfPopup
      v-bind="{ options, context, coreAttributeId, incidentId }"
      :title="'Select number of Wides'"
    />
  </div>
</template>
